import { Component, OnInit } from '@angular/core';
import { Crisp } from 'crisp-sdk-web';

@Component({
  selector: 'app-cancelled-paid',
  templateUrl: './cancelled-paid.component.html',
  styleUrls: ['./cancelled-paid.component.scss']
})
export class CancelledPaidComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  openChat() {
    Crisp.chat.open();
  }
}
